import { observer } from "mobx-react-lite";
import { VStack } from "@chakra-ui/react";

import AddDataForm from "../components/form_page/add_data_form";

const FormPage = observer(() => {
  return (
    <VStack width={"100%"}>
      <VStack
        align={"center"}
        width={"100%"}
        padding={"0 20px"}
        marginBottom={"20px"}
      >
        <AddDataForm />
      </VStack>
    </VStack>
  );
});

export default FormPage;
